import { memo } from 'react';

import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import DirectionIcon from './DirectionIcon';
import Money from './Money';

function TransactionRow({ id, createdAt, summary, direction, amount }) {
  const formattedCreatedAt = dayjs(createdAt).format('MMM D, YYYY');
  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="space-between"
      key={id}
      py="8px"
      width="100%"
    >
      <Stack
        alignItems="center"
        direction="row"
        gap="16px"
      >
        <Stack>
          <DirectionIcon direction={direction} />
        </Stack>
        <Stack
          alignItems="start"
          direction="column"
        >
          <Text
            size="md"
            weight="medium"
          >
            {summary}
          </Text>
          <Text
            size="xs"
            sx={(theme) => ({
              color: theme.palette.text.secondary,
              [theme.breakpoints.up('md')]: {
                fontSize: '13px'
              }
            })}
            whiteSpace="nowrap"
          >
            {formattedCreatedAt}
          </Text>
        </Stack>
      </Stack>
      <Money
        amount={amount}
        direction={direction}
      />
    </Stack>
  );
}

TransactionRow.propTypes = {
  id: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  amount: PropTypes.string.isRequired,

  from: PropTypes.shape({
    accountHolder: PropTypes.string,
    rootingNumber: PropTypes.string,
    fullAccountNumber: PropTypes.string,
    accountNumber: PropTypes.string
  }),
  to: PropTypes.shape({
    accountHolder: PropTypes.string,
    rootingNumber: PropTypes.string,
    fullAccountNumber: PropTypes.string,
    accountNumber: PropTypes.string
  }),

  // FX Details
  currencyConversion: PropTypes.shape({
    originalCurrency: PropTypes.string,
    amountInOriginalCurrency: PropTypes.number,
    fxRate: PropTypes.string
  })
};

export default memo(TransactionRow);
